import { DialogModule } from '@angular/cdk/dialog';
import { Component } from '@angular/core';

@Component({
    selector: 'mapp-ai-terms-of-use',
    standalone: true,
    imports: [DialogModule],
    templateUrl: './ai-terms-of-use.component.html',
    styleUrl: './ai-terms-of-use.component.scss',
})
export class AiTermsOfUseComponent {}
